import {Modal,Spin} from 'iview';
import tipsDialog from '../../include/tipsDialog.vue'
import spin from '../../include/spin'
import zh from '../languages/zh-cn'
import en from '../languages/en-us'
import { resCode } from './OwtAjaxResponseCode'
let lang = navigator.language||navigator.userLanguage;//常规浏览器语言和IE浏览器
lang = lang.substr(0, 2);
var CONFERENCEMEET = null;
let info = {
    code:0,     //0:成功，1表示错误
    info:null, //info：表示返回的信息，0时返回'ok',1时返回错误信息
    data:null //data：成功时返回的数据
};
export  let showTips = (title,content,control,okText,cancelText)=>{
	console.log(CONFERENCEMEET);
	getLang();
    return new Promise((resolve,reject)=>{
        Modal.confirm({
            render:(h) => {
                return h(tipsDialog, {
                    props:{
                        title:title?title:false,
                        content:content,
                        cancelText:cancelText?cancelText:CONFERENCEMEET.CANCEL_NAME,
                        okText:okText?okText:CONFERENCEMEET.CONFIRM_NAME,
                        isClose:control?!control.isClose?control.isClose:true:true,
                        btnNumber:control?control.btnNumber == 1?false:true:true,
                        width:control&&control.width?control.width:480,
                    },
                    on:{
                        close_modal:()=>{
                          if(control && control.isOk){
                              if(control.isOk == true){
                                  resolve()
                              }else if(control.isOk == false){
                                  reject()
                              }else {
                                  return
                              }
                          }
                        },
                       cancel_modal:()=>{
                         reject()
                       },
                       confirm_modal:()=>{
                        resolve()
                       }
                    }
                })
            }
        })
    });
};
export let layerModal = (title,content,control,okText,cancelText)=>{
	console.log(CONFERENCEMEET);
	getLang();
    let layout_vc40 = !cancelText ? 'layui-layer-one':'layui-layer-two',btnArray;
    layout_vc40 = control && control.isStyle == 3 ? 'layui-layer-three' : layout_vc40;
    let canceltext = cancelText?cancelText:CONFERENCEMEET.CANCEL_NAME;
    let oktext = okText?okText:CONFERENCEMEET.CONFIRM_NAME;
    if(control.btnNumber == 1){btnArray = [oktext]}else {btnArray = [oktext,canceltext]};
    return new Promise((resolve,reject)=>{
        layer.open({
            type: 0,
            title:title,
            skin:layout_vc40, //样式类名
            move:false,
            tipsMore:true,
            area: '416px',
            shade:[0.6, '#373737'],
            shadeClose:false,
            btn:btnArray,
            resize:false,
            content: content,
            closeBtn:control?!control.isClose?control.isClose:'1':'1',
            yes:function (index) {
				    resolve();
                layer.close(index);
            },
            btn2:function(index){
			    	reject();
                layer.close(index);

            },
            end:function () {
               //关闭按钮
            }
        })
    })
};
export  let spinLoading = (content,control)=>{
    return new Promise((resolve,reject)=>{
        Spin.show({
            render:(h) => {
                return h(spin, {
                    props:{
                        content:content,
                        isBtn:control?control.isBtn?control.isBtn:false:false,
                        disabled:control?control.isBtn?control.disabled:false:false,
                        loadStyle:control?control.loadStyle?control.loadStyle:0:0
                    },
                    on:{
                        cancel_btn:()=>{
                            resolve()
                        }
                    }
                })
            }
        })
    })
};
//CC接口
/*get current user info
*userInfo
* */
export  let userInfo = (res)=>{
    console.log(res);
    if(res.status == 200){
        return {
            code:0,
            data:res.data.user[0]
        }
    }else {
        return {
            code:1,
            info:'获取用户失败'
        }
    }
};
/*注册：regInfo
* * parameters: res
* return:（Object）code:0or1,info:'ok'or'errorInfo'，data:返回的数据
* */
export let regInfo = (res)=>{
  console.log(res);
  getLang();
  if(res.status){
      /*注册成功*/
      if(res.data.status == 200){
          return {
            code:0,
            info:'ok',
            data:res.data.serverAddress
          }
       }else if(res.data.status == 401){
        console.log(res.data);
        return {
          code:1,
          info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT,
          data:null
        }
      }else if(res.data.status == 402){
        return {
          code:1,
          info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT,
          data:null
        }
      /*跳转到500页*/
      }else if(res.status == 500){
        return {
          code:1,
          info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_OTHER,
          data:null
        }
      }
  }else if(res.response){
     if(res.response.status == 401 || res.response.data.status == 405){
         return {
           code:0,
           info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_OTHER,
           data:null
         }
     }else if(res.response.status == 401 || res.response.data.status == 402 ||res.response.data.status == 404){
      return {
        code:1,
        info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
        data:null
      }
    }
  }else{
    return {
      code:1,
      info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET
    }
  }
};
/**
 *登录：location
 * parameters: res
 * return:（Object）code:0or1,info:'ok'or'errorInfo'，data:返回的数据
 * **/
export let locationInfo = (res)=>{
    console.log(res);
    getLang();
    if(res.status){
        if(res.data.status == 200){
            return info = {
                code:0,
                info:'ok',
                data:res.data.serverAddress
            }
        }else if(res.data.status == 401){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT,
                data:null
            }
        }else if(res.data.status == 402){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT,
                data:null
            }
        }else if(res.status == 500){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_OTHER,
                data:null
            }
        }
    }else {
        return info = {
            code:1,
            info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_NET
        }
    }
};
export let uloginInfo = (res)=>{
    console.log(res);
    getLang();
    if(res.status){
        if(res.data.status == 200){
            return info = {
                code:0,
                info:'ok',
                data:{
                    sid:res.data.sid,
                    cid:res.data.cid,
                    uid:res.data.uid
                }
            }
        }else if(res.data.status == 401){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT
            }
        }else if(res.data.status == 402){
            return info = {
                code:1,
                info:CONFERENCEMEET.LOGIN_FAILER_INFO_ABOUT_ACCOUNT
            }
        }
    }else {
        return info = {
            code:1,
            info:'登录失败，请检查网络设置'
        }
    }
};
//owt接口
export let roomInfo =(res)=>{
    console.log(res);
    getLang();
    if(res.response){
        if(res.response.status == 400){
            return info = {
                code:1,
                info:CONFERENCEMEET.JOIN_ROOM_FAILER_ROOMID,
            }
        }else if(res.response.status == 500){
            return info = {
                code:1,
                info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
            }
        }else if(res.response.status == 404){
            return info = {
                code:1,
                info:CONFERENCEMEET.JOIN_ROOM_FAILER_ROOMID,
            }
        }
    }else if(res.request && res.request.readyState && res.request.readyState == 4){
        return {
            code: 1,
            info:CONFERENCEMEET.JOIN_ROOM_FAILER_NET,
        };
    }else if(res.code && res.code == "ECONNABORTED"){
        return {
            code:1,
            info:CONFERENCEMEET.JOIN_ROOM_FAILER_NET,
        }
    }else {
        return {
            code:0,
            info:'ok',
            data:res.data
        }
    }
};
export let joinRoomInfo = (res)=>{
  console.log(res);
  getLang();
  if(res.status && res.status == 200){
        return {
            code: 0,
            info: 'ok',
            data: Object.assign(res.data,{auth:true})
        }
    }else if(res.response && res.response.status != 200 ){
         if(res.response.status  == 400 && res.response.data.error == 1305){
               return {
                 code: 0,
                 info: 'ok',
                 data: Object.assign(JSON.parse(res.response.data.description),{auth:false})
               }
         }else if(res.response.status  == 400 && res.response.data.error == 1409){
             return {
               code: 1,
               info: CONFERENCEMEET.LOGIN_OUT_OTHER_POINT,
             }
         }else{
             return appServerErrInfo(res.response.data.error)
         }
    }else if(res.message && res.message == "timeout of 30000ms exceeded"){
    return {
      code: 1,
      info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
      isRetry:true
    };
  }else if(res.request && res.request.readyState == 4){
        return {
            code: 1,
            info:CONFERENCEMEET.JOIN_ROOM_FAILER_NET,
            isRetry:true
        };
    }
};
export let accessTokenInfo = (res)=> {
  console.log(res);
  getLang();
  if(res.status && res.status == 200){
        return {
            code: 0,
            info: 'ok',
            data: res.data.token
        }
    }else if(res.response && res.response.status != 200){
       return appServerErrInfo(res.response.data.error)
   }else if(res.message && res.message == "timeout of 30000ms exceeded"){
    return {
      code: 1,
      info:CONFERENCEMEET.JOIN_ROOM_FAILER_OTHER,
      isRetry:true
    };
  }else if(res.request && res.request.readyState == 4){
        return {
            code: 1,
            info:CONFERENCEMEET.JOIN_ROOM_FAILER_NET,
            isRetry:true
        };
    }
};
export let createRoomInfo =(res)=>{
    console.log(res);
    getLang();
    if(res.status && res.status == 200){
        return {
            code: 0,
            info: 'ok',
            data: res.data
        }
    }else  if(res.response && res.response.status != 200){
        return appServerErrInfo(res.response.data.error)
    }else if(res.request && res.request.readyState == 4){
        return {
            code: 1,
            info:CONFERENCEMEET.JOIN_ROOM_FAILER_NET,
            isRetry:true
        };
    }
};
export let delRoomInfo = (res)=>{
	getLang();
    if(res.response && res.response.status == 410){
        return {
            code:2,
            info:res.message,
        }
    }else if(res.response && res.response.status == 400){
        // description: "acccessToken invalid"
        // error: "400"
        return {
            code:2,
            info:res.message,
        }
    }else if(res.status && res.status == 200){
        return {
            code:0,
            info:'操作成功'
        }
    }else{
        return {
            code:1,
            info:CONFERENCEMEET.HANDLE_FAILER_TIPS
        }
    }
};
export let roomStatusInfo = (res)=>{
    console.log(res);
    getLang();
    if(res.response && res.response.status == 404){
        return {
            code:1,
            info:CONFERENCEMEET.HANDLE_FAILER_TIPS
        }
    }else if(res.response && res.response.status == 400){
        //sessionToken status invalid
        return {
            code:1,
            info:CONFERENCEMEET.HANDLE_FAILER_TIPS
        }
    }else if(res.status && res.status == 200){
        return {
            code: 0,
            info: 'ok',
            data: res.data
        }
    }else {
        return {
            code:1,
            info:CONFERENCEMEET.HANDLE_FAILER_TIPS
        }
    }
};
export let SetRoomStatusInfo = (res)=>{
	getLang();
    if(res.status && res.status == 200){return {
        code: 0,
        info: 'ok',
        data: res.data
    }}else if(res.response  && res.response.status && res.response.status == 500){return {
        code:1,
        info:CONFERENCEMEET.HANDLE_FAILER_TIPS
    }}
};
// assignAttendee
export let assignAttendeeInfo = (res)=>{
    console.log(res);
    getLang();
    if(res && res.status && res.status == 200){
        return {
            code: 0,
            info: 'ok',
            data: res.data
        }
    }else{
        return {
            code:1,
            info:CONFERENCEMEET.ASSIGIN_FAILED
        }
    }
};
//owt方法
export let ConferenceInfo = (res)=>{
  console.log(res);
  getLang();
  if(res.participants){
        return {
            code: 0,
            info: 'ok',
            data: res
        }
    }else {
       if(res.message && res.message == 'Room is full'){
            return {
              code: 1,
              info:CONFERENCEMEET.ROOM_FULL_NAME,
            }
       }else{
           return {
               code: 1,
               info:CONFERENCEMEET.LOGIN_FAILER_INFO_JOINROOMFAILE,
           }
       }
    }
};
export let publishInfo =(res)=>{
    console.log(res);
    getLang();
    if(res.id){
       return {
           code: 0,
           info: 'ok',
           data: res
       }
   }else {
       var  TipsInfo = {
           isTips:true,
           TipsConcent:null
       };
       if(res == 'Too many inputs'){
          TipsInfo.TipsConcent = CONFERENCEMEET.INPUT_LIMIT_NUMBER;
          TipsInfo.isTips = true;
      }
      return {
           code:1,
           info:TipsInfo,
       }
   }
};
export let subscribeMixInfo = (res) =>{
   if(res.id){
     return {
       code: 0,
       info: 'ok',
       data: res
     }
   }else{
     return {
       code:1,
       info:TipsInfo,
     }
   }
};
function getLang(){
	if(localStorage.getItem('locale')){
		console.log(JSON.parse(localStorage.getItem('locale')));
		CONFERENCEMEET = JSON.parse(localStorage.getItem('locale')) == 'en' ? en : zh;
	}else{
		CONFERENCEMEET  = lang == 'zh' ? zh : en
	}
};
function appServerErrInfo(code){
    //不需要重试：1200：房间不存在
    console.log(CONFERENCEMEET[resCode[`${code}`]])
    if(code == 1200){
        return {
            code: 1,
            info:CONFERENCEMEET[resCode[`${code}`]],
            isRetry:false
        };
       
    }else{
        return {
            code: 1,
            info:CONFERENCEMEET[resCode[`${code}`]],
            isRetry:true
        };
    }
}
//1 麦克风或摄像头被禁用，请在浏览器中开启摄像头和麦克风权限。

//2 麦克风或摄像头被操作系统禁用或被其他应用程序占用，请检查您的配置。

//3 未检测到摄像头或麦克风，请检查设备是否正常连接。

export let deviceGetErrTips = (deviceErrInfo)=>{
  getLang();
  let deviceTips = CONFERENCEMEET.DIAABLE_MIC_CAMERA_TIPS;
  if(deviceErrInfo.video.info.name){
    switch (deviceErrInfo.video.info.name){
      case 'NotAllowedError':
        deviceTips = CONFERENCEMEET.CHANGE_DEVICE_NOT_ALLOWED_TIPSL;
        break;
      case 'NotReadableError':
        deviceTips = CONFERENCEMEET.CHANGE_DEVICE_NOT_READABLE_TIPS;
        break;
      case 'NotFoundError':
        deviceTips = CONFERENCEMEET.CHANGE_DEVICE_NOT_FOUND_TIPS;
        break;
    }
  }
  return deviceTips
}
